import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/draft')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<main className="grid min-h-screen place-items-center">
			<Outlet />
		</main>
	);
}
